/**
 * Statsig feature-gate names (RND-36404).
 *
 * Keep these snake_case and `access_*`-prefixed to match the exact strings
 * created in the "Hello Heart Happy Hearts Care" Statsig console (same
 * convention as the mobile app — see RND-35269).
 */
export const STATSIG_GATES = {
  ACCESS_REGISTRATION_PILOT: 'access_registration_pilot',
} as const;

export type StatsigGateName = (typeof STATSIG_GATES)[keyof typeof STATSIG_GATES];
